var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "dropbox", staticStyle: { height: "100%" } }, [
        _c("input", {
          ref: "inputFile",
          staticClass: "input-file",
          attrs: {
            type: "file",
            multiple: "",
            name: _vm.uploadFieldName,
            disabled: _vm.isSaving,
            accept: "application/pdf, image/*"
          },
          on: {
            change: function($event) {
              return _vm.filesChange($event.target.files)
            }
          }
        }),
        _c(
          "p",
          [
            _c("v-icon", [_vm._v("mdi-cloud-upload-outline")]),
            _vm._v("Vybrať súbor na nahratie")
          ],
          1
        )
      ]),
      _vm._l(_vm.filesToUpload, function(file, index) {
        return _c("span", { key: index }, [
          _c(
            "div",
            { staticClass: "uploaded-file" },
            [
              _c("v-icon", [_vm._v("mdi-image-outline")]),
              _c(
                "div",
                { staticClass: "upload-progress-container" },
                [
                  _c("div", { staticClass: "upload-filename" }, [
                    _vm._v(_vm._s(file.name))
                  ]),
                  _c("v-progress-linear", {
                    attrs: {
                      height: "6",
                      rounded: "",
                      "background-opacity": "1",
                      value: _vm.uploadProgress
                    }
                  }),
                  _c("div", { staticClass: "upload-progress-size" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.calcSize(file.size)) +
                        " MB z " +
                        _vm._s(Number((file.size / (1024 * 1024)).toFixed(1))) +
                        " MB "
                    )
                  ])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.removeFile(file)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          )
        ])
      }),
      _vm.errorMessage
        ? _c(
            "div",
            {
              staticClass: "negative500 mt-10px ml-5px",
              staticStyle: { "font-size": "16px" }
            },
            [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }